import { Router } from '../routes';

export function App() {
  return <Router />;
}

export default App;
